import { getColumns } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/fields/query';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export const getColumnIds = createSelector([getColumns], (columns) =>
	columns.filter((column) => column.isVisible).map((column) => column.id),
);
